import { toast } from "sonner";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { DownloadPdfButton } from "@/components/ui/download-pdf-button";
import { useDownloadReport } from "@/hooks/useReports";
import type { ReportDownloadInput, ReportKind } from "@/types/reports";

interface Props {
  kind: ReportKind;
  title: string;
  description: string;
  /** Per-report param controls (date range, customer picker, etc.). */
  controls?: React.ReactNode;
  /** Builds the request body from the card's current control state. */
  buildInput: () => ReportDownloadInput;
  /** Optional client-side gate (e.g. QBR needs a customer selected). */
  disabled?: boolean;
}

export function ReportCard({ kind, title, description, controls, buildInput, disabled }: Props) {
  const download = useDownloadReport(kind);
  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        {controls}
        <div className="flex">
          <DownloadPdfButton
            label={`Download ${title}`}
            pending={download.isPending}
            disabled={disabled}
            onClick={() =>
              download.mutate(buildInput(), {
                onError: () => toast.error(`Could not generate the ${title} report.`),
              })
            }
          />
        </div>
      </CardContent>
    </Card>
  );
}
